import { DOOH_REPORT_OTA_LEVELS } from 'sonata-static-storage/lib/entities/doohReport/doohReport.constants';
import { getDoohReportOtaLevelThreshold } from 'sonata-static-storage/lib/helpers/doohReport.helpers';

/** Each rating level takes the same share of the scale bar. */
const BAND_WIDTH_PCT = 100 / DOOH_REPORT_OTA_LEVELS.length;

/**
 * How far (0-100) the OTA fills the scale bar. Each rating band takes a quarter of the bar and
 * the OTA is placed proportionally inside its band: Low spans 0 to the Good threshold, and
 * Excellent spans its threshold to that threshold plus the width of the Strong band, after
 * which the bar is full. Null when there is no OTA.
 */
export function getOtaScaleFillPct(ota: number | null): number | null {
  if (ota === null) {
    return null;
  }
  const good = getDoohReportOtaLevelThreshold('good');
  const strong = getDoohReportOtaLevelThreshold('strong');
  const excellent = getDoohReportOtaLevelThreshold('excellent');
  const bands: [number, number][] = [
    [0, good],
    [good, strong],
    [strong, excellent],
    [excellent, excellent + (excellent - strong)]
  ];
  const bandIndex = bands.findIndex(([, end]) => ota < end);
  if (bandIndex === -1) {
    return 100;
  }
  const [start, end] = bands[bandIndex];
  const withinBand = Math.max(0, (ota - start) / (end - start));

  return (bandIndex + withinBand) * BAND_WIDTH_PCT;
}
